// Module
var code = "<!-- ko if: IsAuthenticated --> <!-- ko if: IsActiveTimers --> <div class=\"allTimers-container_buttonBox\" data-bind=\"click: OpenTimers\"> <!--        <i class=\"fa fa-hourglass-half fa-spin\" aria-hidden=\"true\"></i>--> <i class=\"fa fa-hourglass-half\" aria-hidden=\"true\"></i> </div> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;